import { atom } from 'recoil';

export enum SidebarState {
  FIRST_PAGE,
  SECOND_PAGE,
}

export const sidebarAtom = atom({
  key: 'sidebarState',
  default: SidebarState.FIRST_PAGE,
});
